import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { PalabraClave } from '../../_models/palabra-clave';
import { ActividadEconomica } from '../../_models/actividad-economica';
import { PalabraClaveActividadEconomica } from '../../_models/palabra-clave-actividad-economica';
import { PalabraClaveService } from '../../_services/palabra-clave.service';
import { PalabraClaveActividadEconomicaService } from '../../_services/palabra-clave-actividad-economica.service';
import { forkJoin } from 'rxjs';
import { ActividadEconomicaService } from '../../_services/actividad-economica.service';
import { TipoActividadEconomica } from '../../_enums/enum';

@Component( {
  selector: 'app-palabra-clave-editar',
  templateUrl: 'palabra-clave-editar.component.html'
} )

export class PalabraClaveEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  palClave: PalabraClave;
  lisPalabrasClaves: PalabraClave[] = [];
  formulario: FormGroup;
  submitted = false;
  lisTodasActividadesEconomicas: ActividadEconomica[] = [];
  lisPalabrasClavesActividadesEconomicas: PalabraClaveActividadEconomica[] = [];
  lisActividadesSeleccionadas: ActividadEconomica[] = [];
  lisActividadesDisponibles: ActividadEconomica[] = [];

  tipoActividad = TipoActividadEconomica;

  constructor( private palClaveServicio: PalabraClaveService,
               private palClaveActividadEconomicaServicio: PalabraClaveActividadEconomicaService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private actEconomicasServicio: ActividadEconomicaService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.palClaveServicio.obtenerPorId( params[ 'id' ] ), this.palClaveActividadEconomicaServicio.listadoPorPalabraClave( params[ 'id' ] ) ).subscribe( ( [ palClave, lisPalabraClaveActividades ] ) => {
          this.palClave = palClave;
          this.lisPalabrasClavesActividadesEconomicas = lisPalabraClaveActividades;
          this.carServiciosIniciales();
        } );
      } else {
        this.palClaveServicio.listado().subscribe( conceptos => {
          this.lisPalabrasClaves = conceptos;
          this.carServiciosIniciales();
        } );
      }
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idPalabraClave: [ this.palClave ? this.palClave.idPalabraClave : null ],
      codigo: [ this.palClave ? this.palClave.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombre: [ this.palClave ? this.palClave.nombre : null, [ Validators.required, Validators.maxLength( 100 ) ] ],
      indicadorHabilitado: [ this.palClave ? this.palClave.indicadorHabilitado : false ],
      auditoriaUsuario: [ this.palClave ? this.palClave.auditoriaUsuario : null ],
      auditoriaFecha: [ this.palClave ? this.palClave.auditoriaFecha : null ],
    } );

    this.f.indicadorHabilitado.disable();

    this.actEconomicasServicio.listarPorTipo( this.tipoActividad.CLASE).subscribe( actividades => {
      this.lisTodasActividadesEconomicas = actividades.filter(x => x.indicadorHabilitado);
      this.cargarActividades();
      this.carInformacionInicial = false;
    } );

  }

  cargarActividades() {
    this.lisTodasActividadesEconomicas.map( ( s: ActividadEconomica ) => {
      const a = this.lisPalabrasClavesActividadesEconomicas.find( x => x.idActividadEconomica === s.idActividadEconomica );
      if ( a && a.indicadorHabilitado) {
        this.lisActividadesSeleccionadas.push( s );
      } else {
        this.lisActividadesDisponibles.push( s );
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      const palClave = this.formulario.getRawValue();
      if ( palClave.idPalabraClave ) {
        this.palClaveServicio.actualizar( palClave ).subscribe( rta => {
          const actividades = this.generarActividades( palClave );
          if ( actividades.length > 0 ) {
            this.palClaveActividadEconomicaServicio.bulk( actividades ).subscribe( act => {
              this.navServicio.setMesage( 2 );
              this.guardando = false;
              this.location.back();
            } );
          } else {
            this.navServicio.setMesage( 2 );
            this.guardando = false;
            this.location.back();
          }
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      } else {
        this.palClaveServicio.crear( palClave ).subscribe( rta => {
          palClave.idPalabraClave = rta.idPalabraClave;
          this.f.idPalabraClave.setValue( rta.idPalabraClave );
          const actividades = this.generarActividades( palClave );
          if ( actividades.length > 0 ) {
            this.palClaveActividadEconomicaServicio.bulk( actividades ).subscribe( act => {
              this.navServicio.setMesage( 1 );
              this.guardando = false;
              this.location.back();
            } );
          } else {
            this.navServicio.setMesage( 1 );
            this.guardando = false;
            this.location.back();
          }
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      }
    }
  }

  generarActividades( palClave: PalabraClave ): PalabraClaveActividadEconomica[] {
    const datInsertar = [];
    this.lisActividadesSeleccionadas.map( ( s: ActividadEconomica ) => {
      const a = this.lisPalabrasClavesActividadesEconomicas.find( x => x.idActividadEconomica === s.idActividadEconomica );
      if ( a && !a.indicadorHabilitado ) {
        a.indicadorHabilitado = true;
        datInsertar.push( a );
      } else if ( !a ) {
        const nueActividad = {} as PalabraClaveActividadEconomica;
        nueActividad.idActividadEconomica = s.idActividadEconomica;
        nueActividad.idPalabraClave = palClave.idPalabraClave;
        datInsertar.push( nueActividad );
      }
    } );

    this.lisPalabrasClavesActividadesEconomicas.map( ( s: PalabraClaveActividadEconomica ) => {
      const inhabilitar = this.lisActividadesSeleccionadas.find( x => x.idActividadEconomica === s.idActividadEconomica );
      if ( !inhabilitar && s.indicadorHabilitado ) {
        s.indicadorHabilitado = false;
        datInsertar.push( s );
      }
    } );

    return datInsertar;
  }

  regresar( dirty: boolean ) {
    if ( dirty || this.validarCambios() ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCambios(): boolean {
    return this.lisPalabrasClavesActividadesEconomicas.length !== this.lisActividadesSeleccionadas.length ||
      this.lisPalabrasClavesActividadesEconomicas.filter( x => this.lisActividadesSeleccionadas.find( y => y.idActividadEconomica === x.idActividadEconomica ) !== undefined ).length !== this.lisPalabrasClavesActividadesEconomicas.length;
  }

  validarCodigo() {
    this.codExiste = this.lisPalabrasClaves.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  cambioItems() {
    if ( this.lisActividadesSeleccionadas.length > 0 ) {
      this.f.indicadorHabilitado.setValue( true );
    } else {
      this.f.indicadorHabilitado.setValue( false );
    }
  }


}
